export const SIDEBAR_TYPE = {
    DEFAULT: 'sidebar',
    HORIZONTAL: 'horizontal'
  }